import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { FmcgIndustryPage } from "@/components/site/FmcgIndustryPage";
import { FMCG_META_DESCRIPTION } from "@/content/meta/FmcgIndustryPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/industries/fmcg")({
  head: () => ({
    meta: [
      { title: "FMCG Media Monitoring & Analysis | Perceptica" },
      { name: "description", content: FMCG_META_DESCRIPTION },
      { property: "og:title", content: "FMCG Media Monitoring & Analysis | Perceptica" },
      { property: "og:description", content: FMCG_META_DESCRIPTION },
      { name: "twitter:title", content: "FMCG Media Monitoring & Analysis | Perceptica" },
      { name: "twitter:description", content: FMCG_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://perceptica.com/industries/fmcg" },
      ...ogImageMeta("en", "/industries/fmcg"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/industries/fmcg" }),
  }),
  component: FmcgIndustryPage,
});
